import React from 'react';
import { Tooltip } from 'antd';
import { bandLabel, bandColor } from '../helpers';

type Props = { band: number | null; title?: string };

/** A/B/C/D quality band pill (real `band` field from Analysis2Type). */
const BandChip: React.FC<Props> = ({ band, title }) => {
  const label = bandLabel(band);
  if (!label) {
    return (
      <span className="studio2__band" style={{ background: '#c2ccdb' }}>
        —
      </span>
    );
  }
  const chip = (
    <span className="studio2__band" style={{ background: bandColor(band) }}>
      {label}
    </span>
  );
  return title ? <Tooltip title={title}>{chip}</Tooltip> : chip;
};

export default BandChip;
